<template>
  <v-app>
    <!-- App Bar -->
    <v-app-bar app flat class="header-contrast">
      <template v-if="mailCount > 0">
        <v-badge :content="mailCount" color="error" overlap class="me-2">
          <v-app-bar-nav-icon @click="toggleDrawer" />
        </v-badge>
      </template>
      <template v-else>
        <v-app-bar-nav-icon @click="toggleDrawer" />
      </template>
      <v-toolbar-title>Grand Fantasia Zephyr</v-toolbar-title>
      <v-spacer />
      <!-- Idioma -->
      <div class="d-flex align-center">
        Idioma
        <v-menu offset-y>
          <template #activator="{ props }">
            <v-btn icon v-bind="props">
              <img :src="currentLang.flag" :alt="currentLang.label" width="24" />
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(lang, code) in languages"
              :key="code"
              @click="changeLocale(code)"
            >
              <v-list-item-avatar>
                <img :src="lang.flag" :alt="lang.label" width="24" />
              </v-list-item-avatar>
              <v-list-item-title>{{ lang.label }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>

    <!-- Navigation Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      app
      disable-resize-watcher
      :mini-variant="miniVariant"
      permanent
      class="drawer-contrast"
    >
      <template v-if="!auth.token">
        <v-list density="compact">
          <v-list-item @click="goHome" prepend-icon="mdi-home" :title="$t('menu.home')" link />
          <v-list-item @click="goLogin" prepend-icon="mdi-login" :title="$t('menu.login')" link />
          <v-list-item @click="goRegister" prepend-icon="mdi-account-plus" :title="$t('menu.register')" link />
          <v-list-item @click="goDownload" prepend-icon="mdi-download" :title="$t('menu.download')" link />
        </v-list>
      </template>
      <template v-else>
        <v-list class="pt-4 pb-2">
          <v-list-item
            class="d-flex flex-column align-center"
            clickable
            @click="triggerFileSelect"
          >
            <v-avatar size="80">
              <img class="avatar-img" :src="avatarUrl" alt="Avatar" />
            </v-avatar>
            <v-list-item-title class="mt-2">{{ auth.user.mid }}</v-list-item-title>
            <v-list-item-subtitle>{{ $t('menu.loggedAs') }}</v-list-item-subtitle>
          </v-list-item>
          <input
            ref="fileInput"
            type="file"
            accept="image/*"
            class="d-none"
            @change="onFileChange"
          />
        </v-list>
        <v-divider />
        <v-list density="compact" nav>
          <v-list-item @click="goHome" prepend-icon="mdi-home" :title="$t('menu.home')" link />
          <v-divider />
          <v-list-item link prepend-icon="mdi-account-circle" :title="$t('menu.info')" @click="goMinhasInformacoes" />
          <v-list-item link prepend-icon="mdi-lock-reset" :title="$t('menu.changePassword')" @click="goAlterarSenha" />
          <v-list-item link prepend-icon="mdi-inbox" :title="$t('menu.inbox')" @click="goCaixaMensagens">
            <template #append>
              <v-badge v-if="mailCount > 0" :content="mailCount" color="error" overlap />
            </template>
          </v-list-item>
          <v-list-item link prepend-icon="mdi-book" :title="$t('menu.wikia')" @click="goWikia" />
          <v-list-item link prepend-icon="mdi-sword" :title="$t('menu.ranked')" @click="goRanked" />
          <v-list-item
            v-if="!smAndDown"
            link
            prepend-icon="mdi-test-tube"
            :title="$t('menu.alquimia')"
            @click="goAlquimia"
          />
          <v-list-item link prepend-icon="mdi-ray-start-arrow" :title="$t('menu.escala')" @click="ViewEscala" />
          <v-list-item link prepend-icon="mdi-update" :title="$t('menu.atts')" @click="goPathNotes" />
          <v-divider class="my-2" />
          <v-list-item link prepend-icon="mdi-engine" :title="$t('menu.servicos')" @click="goServicos" />
          <v-list-item link prepend-icon="mdi-cash" :title="$t('menu.coinsBr')" @click="goZenphyrCoins" />
          <v-list-item link prepend-icon="mdi-cash" :title="$t('menu.coinsInt')" @click="goZenphyrCoinsInter" />
          <v-divider class="my-2" />
          <v-list-item
            v-if="!smAndDown"
            link
            prepend-icon="mdi-clover"
            :title="$t('menu.roulette')"
            @click="goRoletaDaSorte"
          />
         <!--  <v-list-item
            v-if="!smAndDown"
            link
            prepend-icon="mdi-horseshoe"
            :title="$t('menu.casino')"
            @click="ViewCassino"
          /> -->
          <v-list-item @click="goColetaDiaria" prepend-icon="mdi-calendar-today" :title="$t('menu.daily')" link />
          <v-divider class="my-2" />
          <v-list-item @click="logout" prepend-icon="mdi-logout" :title="$t('menu.logout')" link />
        </v-list>
      </template>
    </v-navigation-drawer>

    <!-- Cropper Dialog -->
    <v-dialog v-model="showCropper" max-width="700px">
      <v-card>
        <v-card-title>{{ $t('cropper.title') }}</v-card-title>
        <v-card-text>
          <div class="cropper-container">
            <cropper
              ref="cropperRef"
              :src="selectedImage"
              :stencil-props="{ aspectRatio: 1 }"
              class="my-cropper"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cancelCrop">{{ $t('cropper.cancel') }}</v-btn>
          <v-btn color="primary" @click="applyCrop">{{ $t('cropper.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Main Content -->
    <v-main app style="height: 100%">
      <router-view />
    </v-main>

    <!-- Footer -->
    <AppFooter :site-name="$t('footer.copy', { year, site: siteName })" />

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" location="top right" :timeout="snackbarDuration" vertical>
      {{ t('snackbar.newMessages', { count: mailCount }) }}
      <template #action>
        <v-btn icon @click="closeSnackbar"><v-icon>mdi-close</v-icon></v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script setup>
import { ref, nextTick, onMounted, onUnmounted, watch, computed } from 'vue'
import { useTheme, useDisplay } from 'vuetify'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

// Cropper
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

import { auth, clearAuth, updateProfileUrl } from './auth.js'
import { fetchMail, fetchMe, uploadAvatar } from './services/api.js'
import AppFooter from './components/AppFooter.vue'

// Pega a URL do backend do .env do front (Vue CLI)
const BACKEND_URL = (process.env.VUE_APP_BACKEND_URL || '').replace(/\/+$/, '')

/**
 * Normaliza qualquer URL vinda do DB:
 * - caminhos absolutos em /uploads são prefixados com BACKEND_URL
 * - corrige eventuais "https://https://..."
 */
function normalizeUrl(url = '') {
  let u = url.trim()
  if (u.startsWith('/')) {
    return BACKEND_URL + u
  }
  // caso alguém tenha salvo com duplo https://
  return u.replace(/^(https?:\/\/)+/, '$1')
}

// Avatar & Cropper
const defaultAvatar   = 'https://randomuser.me/api/portraits/lego/1.jpg'
const avatarUrl       = ref(defaultAvatar)
const fileInput       = ref(null)
const showCropper     = ref(false)
const selectedImage   = ref(null)
const cropperRef      = ref(null)

function triggerFileSelect() {
  fileInput.value.click()
}

async function onFileChange(e) {
  const file = e.target.files[0]
  if (!file) return
  selectedImage.value = URL.createObjectURL(file)
  showCropper.value = true
  await nextTick()
}

function cancelCrop() {
  showCropper.value = false
  URL.revokeObjectURL(selectedImage.value)
  selectedImage.value = null
}

async function applyCrop() {
  const cropper = cropperRef.value
  if (!cropper) return
  const { canvas } = cropper.getResult()
  if (!canvas) return
  canvas.toBlob(async blob => {
    if (!blob) return
    const file = new File([blob], 'avatar.jpg', { type: 'image/jpeg' })
    try {
      const { url } = await uploadAvatar(auth.token, file)
      avatarUrl.value = normalizeUrl(url)
      updateProfileUrl(avatarUrl.value)
    } catch (err) {
      console.error('Erro no upload do avatar:', err)
    }
    cancelCrop()
  }, 'image/jpeg', 0.9)
}

// Mail & Snackbar
const mailCount        = ref(0)
const snackbar         = ref(false)
const snackbarDuration = ref(5000)
async function loadMailCount() {
  if (!auth.token) { mailCount.value = 0; return }
  try {
    const { count } = await fetchMail(auth.token)
    if (count > mailCount.value) snackbar.value = true
    mailCount.value = count
  } catch (e) { console.error(e) }
}
let intervalId = null

onMounted(async () => {
  if (auth.token) {
    try {
      const { user } = await fetchMe(auth.token)
      auth.user.mid = user.mid
      avatarUrl.value = user.url_perfil
        ? normalizeUrl(user.url_perfil)
        : defaultAvatar
    } catch {
      avatarUrl.value = defaultAvatar
    }
  }
  loadMailCount()
  intervalId = setInterval(loadMailCount, 10000)
})
onUnmounted(() => clearInterval(intervalId))

// Theme & Drawer
const theme       = useTheme()
const STORAGE_KEY = 'app-theme'
const saved       = localStorage.getItem(STORAGE_KEY)
if (['light','dark'].includes(saved)) theme.global.name.value = saved

const drawer       = ref(false)
const { smAndDown }= useDisplay()
watch(smAndDown, m => m && (drawer.value = false))
const miniVariant  = computed(() => smAndDown.value && !drawer.value)
function toggleDrawer() { drawer.value = !drawer.value }

// Navigation & Auth
const router = useRouter()
const goHome = () => router.push({ name: 'Home' })
const goLogin = () => router.push({ name: 'Login' })
const goRegister = () => router.push({ name: 'Register' })
const goDownload = () => router.push({ name: 'Download' })
const goMinhasInformacoes = () => router.push({ name: 'MinhasInformacoes' })
const goAlterarSenha = () => router.push({ name: 'AlterarSenha' })
const goCaixaMensagens = () => router.push({ name: 'CaixaMensagens' })
const goWikia = () => router.push({ name: 'ViewWikia' })
const goRanked = () => router.push({ name: 'ViewRanked' })
const goAlquimia = () => router.push({ name: 'ViewAlquimia' })
const ViewEscala = () => router.push({ name: 'ViewEscala' })
const goPathNotes = () => router.push({ name: 'ViewAtualizacoes' })
const goZenphyrCoins = () => router.push({ name: 'ZenphyrCoins' })
const goZenphyrCoinsInter = () => router.push({ name: 'ZenphyrCoinsInter' })
const goRoletaDaSorte = () => router.push({ name: 'RoletaDaSorte' })
/* const ViewCassino = () => router.push({ name: 'Home' }) */
const goColetaDiaria = () => router.push({ name: 'ColetaDiaria' })
const goServicos = () => router.push({ name: 'ViewServicos' })
function logout() {
  clearAuth()
  router.push({ name: 'Login' })
}

// i18n
const { locale, t } = useI18n({ useScope: 'global' })
const languages     = {
  pt: { label: 'Português', flag: 'https://flagcdn.com/w20/br.png' },
  es: { label: 'Español',   flag: 'https://flagcdn.com/w20/es.png' },
  fr: { label: 'Français',  flag: 'https://flagcdn.com/w20/fr.png' },
  en: { label: 'English',   flag: 'https://flagcdn.com/w20/us.png' },
  de: { label: 'Alemão',   flag: 'https://flagcdn.com/w20/de.png' }
}
function changeLocale(code) {
  locale.value = code
  localStorage.setItem('locale', code)
}
const currentLang = computed(() => languages[locale.value] || languages.pt)

// Footer & Helpers
const year = new Date().getFullYear()
const siteName = 'Grand Fantasia Zephyr'
const closeSnackbar = () => (snackbar.value = false)
</script>

<style scoped>
.header-contrast {
  background: linear-gradient(to right, #000, #2a004f, #4b0082, #240cc4);
  color: white;
}
.drawer-contrast {
  background: linear-gradient(to bottom, #000, #2a004f, #4b0082, #240cc4);
  color: white;
}
.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.cropper-container {
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.my-cropper {
  width: 100%;
  height: 100%;
}
</style>
